module.exports = __webpack_public_path__ + "img/Abcn.362e7516.png";